import React from 'react';

import {TriangleLocation, TriangleState} from 'notebook/tables/errors/ErrorTriangle';

import ModalAnchor from '../../ui-library/ModalAnchor';
import {AssayValidationDisplayInfo} from './ValidationConstants';
import ValidationErrorTriangle, {statusToTriangleState} from './ValidationErrorTriangle';
import {ValidationHistoryModal} from './ValidationHistoryModal';

export function validationIndicatorWillRender(props: ValidationIndicatorProps): boolean {
  if (!props.assayValidationToDisplay) {
    return false;
  }
  const triangleState = statusToTriangleState(
    props.assayValidationToDisplay.status,
    props.assayValidationToDisplay.comment,
    props.assayValidationToDisplay.history
  );
  return triangleState !== TriangleState.VALID_NO_TRIANGLE;
}

interface ValidationIndicatorState {
  isModalOpen: boolean;
}
export interface ValidationIndicatorProps {
  assayValidationToDisplay?: AssayValidationDisplayInfo | null;
  location: TriangleLocation;
}
export default class ValidationIndicator extends React.Component<
  ValidationIndicatorProps,
  ValidationIndicatorState
> {
  override state: ValidationIndicatorState = {
    isModalOpen: false,
  };

  _handleOpenModal = (): void => {
    this.setState({isModalOpen: true});
  };

  _handleCloseModal = (): void => {
    this.setState({isModalOpen: false});
  };

  override render(): JSX.Element | null {
    if (!this.props.assayValidationToDisplay) {
      return null;
    }

    const history = this.props.assayValidationToDisplay.history;
    return (
      <div>
        {history && (
          <ModalAnchor open={this.state.isModalOpen}>
            <ValidationHistoryModal onRequestClose={this._handleCloseModal} history={history} />
          </ModalAnchor>
        )}
        <ValidationErrorTriangle
          status={this.props.assayValidationToDisplay.status}
          comment={this.props.assayValidationToDisplay.comment}
          history={history}
          location={this.props.location}
          onClick={this._handleOpenModal}
        />
      </div>
    );
  }
}
